import endpoints from "api/endpoints";

export default (
  { resultKey = "isCommissionDeleted", commissionId } = {
    resultKey: "isCommissionDeleted",
  }
) => ({
  url: endpoints.getActionCommissionUrl(commissionId),
  transform: (response) => !response.error,
  transformResult: (response) => ({
    [resultKey]: !response.error,
  }),
  queryKey: endpoints.getActionCommissionUrl(commissionId),
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: "application/json",
    },
    method: "DELETE",
  },
  update: {},
  updateResult: {
    [resultKey]: (prevResult, result) => result,
  },
});
